document.addEventListener('DOMContentLoaded', function () {
  var amazonConfig = {
    'magic-bag-hot-cold-pelvic-compress': 'https://www.amazon.ca/Original-Magic-Bag-menstrual-abdominal/dp/B0FDBQXST3?maas=maas_adg_32878F56E1D7CA5229A8F9E1D774E3AB_afap_abs&ref_=aa_maas&tag=maas',
    'compresse-chaude-froide-pelvienne': 'https://www.amazon.ca/Original-Magic-Bag-menstrual-abdominal/dp/B0FDBQXST3?maas=maas_adg_32878F56E1D7CA5229A8F9E1D774E3AB_afap_abs&ref_=aa_maas&tag=maas'
  };

  function getHandle() {
    var parts = window.location.pathname.split('/').filter(Boolean);
    return parts[parts.length - 1] || '';
  }

  function getLang() {
    if (window.location.pathname.indexOf('/fr/') === 0) return 'fr';
    if ((document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0) return 'fr';
    return 'en';
  }

  function findAddToCartBtn() {
    return (
      document.querySelector('button.ecom-product-single__add-to-cart--submit.ecom-flex') ||
      document.querySelector('button[name="add"]') ||
      document.querySelector('button[type="submit"]')
    );
  }

  function addAmazonBtn() {
    if (document.querySelector('.masdel-amazon-buy-btn')) return;

    var handle = getHandle();
    var url = amazonConfig[handle];
    if (!url) return;

    var addToCart = findAddToCartBtn();
    if (!addToCart) return;

    var lang = getLang();
    var label = lang === 'fr' ? 'Acheter sur Amazon' : 'Buy On Amazon';

    var btn = document.createElement('a');
    btn.href = url;
    btn.target = '_blank';
    btn.rel = 'noopener noreferrer';
    btn.className = 'masdel-amazon-buy-btn';
    btn.innerHTML =
      '<img src="https://cdn.shopify.com/s/files/1/0854/0445/1100/files/logo-amazon-gris.svg?v=1765210649" class="masdel-amazon-buy-icon masdel-amazon-buy-icon--gray" alt="Amazon">' +
      '<img src="https://cdn.shopify.com/s/files/1/0854/0445/1100/files/logo-amazon-jaune.svg?v=1765210649" class="masdel-amazon-buy-icon masdel-amazon-buy-icon--yellow" alt="Amazon">' +
      '<span>' + label + '</span>';

    var form = addToCart.closest('form');
    if (form) {
      form.insertAdjacentElement('afterend', btn);
    } else {
      addToCart.insertAdjacentElement('afterend', btn);
    }
  }

  addAmazonBtn();
  var tries = 0;
  var timer = setInterval(function () {
    if (document.querySelector('.masdel-amazon-buy-btn')) { clearInterval(timer); return; }
    addAmazonBtn();
    tries++;
    if (tries > 20) clearInterval(timer);
  }, 400);
});
